export default {
  balances: 'Balances',
  name: 'Name',
  balance: 'Balance',
  createdAt: 'Date & Time ({tzOffset})',
  authoredBy: 'Authored By',
  newDeposit: 'New Deposit',
  dialogConfirmationMessage: 'This action will automatically disable the "Orders without deposits" option for this user, do you wish to continue?',
  totalCityBalance: 'Balance {city}: {amount}',
};
